import { PageContentWrapper } from 'app/member/layouts/wrapper/page-content';
import React from 'react';
import { Routes, Route } from 'react-router-dom';

import { SMSListPage } from './list/list';
import { SMSViewPage } from './views';

export const SMSModule = () => {
  return (
    <>
      <PageContentWrapper>
        <Routes>
          <Route path="/*" index element={<SMSListPage />} />
          <Route path="/:id" element={<SMSViewPage />} />
        </Routes>
      </PageContentWrapper>
    </>
  );
};
